<template>
  <div>
    <Header />
    <LoadingDialog
      ref="LoadingDialog"
      message="Please stand by..."
      specific
    />
    <v-container grid-list-md fluid class="container-style">
      <div class="container-header">
        <span>Online Enrollments</span>
      </div>
      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="onlineEnrollments"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <tr>
                <td>
                  <router-link :to="{name: 'online-enrollment-detail', params: { id: props.item.id }}">
                    {{ props.item.student_full_name }}
                  </router-link>
                </td>
                <td>
                  {{ props.item.date_added }}
                </td>
                <td>
                  {{ props.item.student_grade_level_display }}
                </td>
                <td>
                  {{ props.item.payment_type_display }}
                </td>
                <td>
                  <v-btn
                    @click="deleteOnlineEnrollment(props.item.id)"
                    color="light-gray"
                    :icon="true"
                  >
                    <v-icon
                      color="red darken-4"
                      size="15px"
                    >
                      delete
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import {
  mapState,
  mapActions
} from "vuex";

import Header from '@/components/Header.vue'
import LoadingDialog from '@/components/LoadingDialog.vue'

export default {
  name: "OnlineEnrollments",
  components: {
    Header,
    LoadingDialog,
  },
  computed: {
    ...mapState(['onlineEnrollments']),
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 25,
      },
      headers: [
        {
          text: 'Student',
          value: 'student_full_name',
          width: '10%'
        },
        {
          text: 'Date Added',
          value: 'date_added',
          width: '10%'
        },
        {
          text: 'Grade Level',
          value: 'student_grade_level_display',
          width: '10%'
        },
        {
          text: 'Payment Type',
          value: 'payment_type_display',
          width: '10%'
        },
        {
          text: '',
          value: null,
          width: '10%'
        },
      ],
    }
  },
  methods: {
    ...mapActions(['getOnlineEnrollments']),

    deleteOnlineEnrollment(id) {
      if (confirm('Are you sure you want delete this online enrollment?')) {
        axios.delete(`/api/online-enrollment/${id}/`)
        .finally(() => {
          this.$toastr('success', 'Action Success', 'Success')
          this.getOnlineEnrollments()
        })
      }
    }
  },
  created () {
  },
  mounted () {
    this.$refs.LoadingDialog.dialog = true
    this.getOnlineEnrollments()
      .finally(() => this.$refs.LoadingDialog.dialog = false)
  },
}
</script>
